import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import LinkUnLinkMenuWithStoresModal from "features/menus/components/LinkUnLinkMenuWithStoresModal";
import AppModal from "components/ui/AppModal";
import AppButton from "components/ui/AppButton";
import AppOutlineButton from "components/ui/AppOutlineButton";

function LinkStoresWithMenu({
  menuState,
  updateState,
  stores,
  loading,
  linkMenu,
}) {
  const { t } = useTranslation();
  const { isLoading } = useSelector((state) => state.LoaderReducer);
  const handleClose = () => {
    updateState("isLinkMenuWithStoresModalOpen", false);
    updateState("linkedStores", []);
  };

  const footer = (
    <div className="flex justify-end space-x-2">
      <AppOutlineButton
        disabled={loading || isLoading}
        onClick={handleClose}
      >
        {t("Cancel")}
      </AppOutlineButton>
      <AppButton
        disabled={
          menuState.linkedStores?.length === 0 || loading || isLoading
        }
        onClick={linkMenu}
      >
        {t("Save")}
      </AppButton>
    </div>
  );

  return (
    <AppModal
      open={menuState.isLinkMenuWithStoresModalOpen}
      onClose={handleClose}
      footer={footer}
      title={t("Connections")}
      width={500}
      bodyStyle={{ overflowY: "auto", maxHeight: "calc(100vh - 400px)" }}
    >
      <LinkUnLinkMenuWithStoresModal
        {...{
          stores,
          loading,
        }}
        selectedStores={menuState.linkedStores}
        setselectedStores={(val) => updateState("linkedStores", val)}
        menus={menuState.addedMenus}
      />
    </AppModal>
  );
}

export default LinkStoresWithMenu;
